<div class="bsc-card-container">
  <!-- Card Content -->
  <div *ngIf="processedMetrics?.length > 0">
    <div class="table-responsive bsc-card" style="height: 100%">
      <table
        id="table-sparkline"
        class="table"
        style="font-size: 0.5rem; border-top: medium none; table-layout: fixed"
      >
        <tbody id="tbody-sparkline" class="example-list">
          <tr
            *ngFor="let metric of processedMetrics; index as i"
            class="example-box w-100"
          >
            <td
              *ngIf="isFirstMetricOfGroup(i)"
              [attr.rowspan]="metric.groupLength"
              class="fw-bold"
            >
              {{ metric.groupName }}
            </td>

            <td
            >
              <span
                class="fw-bold"
                style="color:rgb(0, 119, 255)"
              >
                {{ metric?.display_name }}&nbsp;
                <span *ngIf="metric?.unit_name">({{ metric?.unit_name }})</span>
              </span>
            </td>

            <td>
              <div *ngIf="hasTrendData(metric)" [chart]="metric?.trend"></div>
              <div *ngIf="!hasTrendData(metric)" class="no-data">
                {{ commonText.no_records_found }}
              </div>
            </td>

            <td>
              <span class="fw-bold">{{ getFormattedValue(metric?.actual_value) }}</span>
            </td>

            <td class="text-center" *ngIf="metric.change != 'false'">
              <div
                class="fw-bold"
                [ngClass]="{
                  spanRed: metric?.status === 'red',
                  spanGreen: metric?.status === 'green',
                  spanNeutral: metric?.status === 'gray',
                  spanAmber: metric?.status === 'amber'
                }"
              >
                {{ getFormattedValue(metric?.change) }}
              </div>
              <span class="px-2 d-block"
                >{{ metric?.variance_per | appFormat : "float" }}%</span
              >
            </td>
            <td *ngIf="metric.change == 'false'"></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div class="row" *ngIf="!processedMetrics?.length">
    <div class="col-md-5 mx-auto mt-5">
      <img
        src="./assets/images/no-record.png"
        class="mt-3"
        height="100%"
        width="100%"
        alt="no records"
      />
    </div>
    <div class="col-md-8 mx-auto">
      <p class="text-center text-muted mt-2 font-weight-bold mb-1">
        {{ noDataMessage }}
      </p>
    </div>
  </div>
</div>